/**
 * 行政管理
 */
const administratorRouter = {
  path: '/administration',
  component: () => import('@/views/layout'),
  redirect: '/administration/purchase/list',
  alwaysShow: true,
  meta: {
    title: '行政管理',
    icon: require('@/assets/slider/xingzheng.png')
  },
  children: [{
    path: 'purchase/list',
    name: 'purchase_manage',
    component: () => import('@/views/administration_manage/purchase_manage/components/CG'),
    meta: {
      title: '采购',
      keepAlive: true
    }
  },

  {
    path: 'warehouse/list',
    name: 'warehouse_manage',
    component: () => import('@/views/administration_manage/warehouse_manage'),
    meta: {
      title: '库管',
      keepAlive: true
    }
  },
  {
    path: 'assets/list',
    name: 'assets_manage',
    component: () => import('@/views/administration_manage/assets_manage'),
    meta: {
      title: '固定资产',
      keepAlive: true
    }
  },
  {
    path: 'scrap/list',
    name: 'scrap_manage',
    component: () => import('@/views/administration_manage/scrap_manage'),
    meta: {
      title: '报废',
      keepAlive: true
    }
  }

  ]
}

export default administratorRouter
